import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterBy',
	standalone: true
})
export class FilterByPipe implements PipeTransform {

	/**
	 * @description Used to filter out fields that do not have the filterString present within it.
	 **/
	public transform(value: any[], fieldToFilterBy = '', filterString = '') {
		const sortedCopy = [...value];
		return this.filter(sortedCopy, fieldToFilterBy, filterString);
	}

	private filter(list: any[], fieldToFilterBy: string, filterString: string) {
		filterString = filterString.toLowerCase();
		list = list.filter((elem) => {
			if(elem[fieldToFilterBy] && elem[fieldToFilterBy].toLowerCase().includes(filterString)) {
				return elem;
			}
		});
		return list;
	}
}
